import { render, staticRenderFns } from "./ProfessionCategoryCrudModal.vue?vue&type=template&id=4cf8e674&"
import script from "./ProfessionCategoryCrudModal.vue?vue&type=script&lang=js&"
export * from "./ProfessionCategoryCrudModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports